module.exports = require("npm:iframe-resizer@3.5.8/index.js");